import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import { LoadingService } from '../../../services/loading.service';
import { FaceIdHandler } from './handler/face-id.handler';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { FaceCode } from 'src/app/shared/interfaces/face-id.interface';
import { UiActions } from 'src/app/store/actions';
import { DataNotClientService } from 'src/app/services/data-not-client.service';
import { AccountFormatService } from 'src/app/services/account-format.service';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { GenericErrorType, OCRResponseStatus, StepsNotClientTypes } from 'src/app/shared/enums';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Suggestions, OcrSuggestionResponse } from 'src/app/services/static-assets';

@Component({
  selector: 'app-face-recognition',
  templateUrl: './face-recognition.component.html',
  styleUrls: ['../../../global.scss', './face-recognition.component.scss']
})
export class FaceRecognitionComponent implements OnInit, OnDestroy {
  requestSent = false;
  showIframe = false;
  validationError: Suggestions;
  suggestionData: OcrSuggestionResponse;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  subs = new Subscription();
  item = 0;
  retries = 3;
  soliId;
  ocrUrl: SafeUrl;
  genericErrorInfo = {
    ddmessage: 'default error',
    code: '02',
    genericError: GenericErrorType.DEFAULT_ERROR,
    error: null
  };

  constructor(
    public accountFormatService: AccountFormatService,
    public loadingService: LoadingService,
    private store: Store<OnboardingProductsStore.AppState>,
    private datadogService: DatadogService,
    private faceIdHandler: FaceIdHandler,
    private dataNotClientService: DataNotClientService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.setService();
    this.store.select('stepsNoClient').subscribe();

    this.subs.add(this.faceIdHandler.getSuggestions()
    .subscribe((data) => {
      this.suggestionData = data;
      this.loadingService.loading = false;
    }));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  setService() {
    const googleAnalytics = {
      is_joint_account: this.dataNotClientService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataNotClientService.getWorkActivityType() ? this.dataNotClientService.getWorkActivityType() : 'No informado',
        dateEntryWork: this.dataNotClientService.getDateEntryWork() ? this.dataNotClientService.getDateEntryWork() : 'No informado',
        companyName: this.dataNotClientService.getCompanyName() ? this.dataNotClientService.getCompanyName() : 'No informado',
        rucCompany: this.dataNotClientService.getRucCompany() ? this.dataNotClientService.getRucCompany() : 'No informado',
        profession: this.dataNotClientService.getProfession() ? this.dataNotClientService.getProfession() : 'No informado'
      },
      currency_account_type: this.dataNotClientService.getCurrencyType()
    };
    this.store.dispatch(TagPage({text: 'face-recognition', extras: googleAnalytics}));
  }

  goNext() {
    this.showBiometric();
  }

  getEvent(event) {
    if (!event.data?.type) {
      if (event.origin?.includes(environment.SERVICES.ZYTRUST_HOST)) {
        if (typeof(event.data) === 'object') {
          this.partialAttempt(event);
        } else if (typeof(event.data) === 'string') {
          this.finalEvent(event);
        }
      }
    }
  }

  partialAttempt(event) {
    const {codigo: zcode, descripcion: description, etapa: stage} = event.data;
    this.datadogService.addCustomEvent('Intento parcial recibido', environment.mode, {zcode, description});
    if (!environment.production && zcode === undefined) {
      return;
    }
    this.faceIdHandler.partialAttempt(zcode, description, stage).subscribe(
      () => {
        this.datadogService.addCustomEvent('Intento parcial notificado', environment.mode);
      },
      (e) => {
        this.datadogService.addCustomEvent('Catch registro intento parcial', environment.mode, { error: e });
      }
    );
  }

  finalEvent(event) {
    this.datadogService.addCustomEvent('Recibo evento final zytrust', environment.mode, { channel: 'no client' });
    this.retries--;
      const eventData = event.data.split(/\:/);
      this.loadingService.loading = false;
      this.toogleModal();
      this.sendToValidate(eventData[0], event.data);
  }

  async showBiometric(): Promise<void> {
    this.datadogService.addCustomEvent('Inicio configuración biométrica', environment.mode, { channel: 'no client' });
    this.requestSent = true;
    this.validationError = undefined;
    await this.faceIdHandler.requestApplication().subscribe(
      (res) => {
        const url = res.message.url;
        const soliId = res.message.soliId;
        console.log('Response del aplication: ', res.message);
        this.ocrUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.datadogService.addCustomEvent('Solicitud generada', environment.mode, { soliId });
        window.addEventListener('message', this.getEvent.bind(this), false);
      },
      (err) => {
        console.log('face error:', err);
        this.datadogService.addCustomEvent('Catch try generación de solicitud zytrust', environment.mode, { error: err });
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
      }
    );
    this.toogleModal();
  }

  toogleModal() {
    this.showIframe = !this.showIframe;
  }

  goToDesk(): void {
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING }));
  }

  sendToValidate(code: FaceCode, error ?) {
    this.loadingService.loading = false;
    if (code === FaceCode.ok) {
      this.datadogService.addCustomEvent('Reconocimiento exitoso', environment.mode, { code });
    } else if (code === FaceCode.invalid) {
      this.setGenericErrorObject('Fallo Face-id por código', code, GenericErrorType.REJECTED_REQUEST, error);
    } else if (code === FaceCode.existingContract ||
      code === FaceCode.applicationNotFound ||
      code === FaceCode.deniedApplication) {
      this.setGenericErrorObject('Fallo Face-id por código', code, GenericErrorType.EXIST_CLIENT, error);
    } else if (code === FaceCode.unsavedDocument ||
      code === FaceCode.intermittence ||
      code === FaceCode.biometricError ||
      code === FaceCode.errorService) {
      this.setGenericErrorObject('Fallo Face-id por código', code, GenericErrorType.PROCCESS_ERROR, error);
    } else {
      this.setGenericErrorObject('Fallo Face-id por código', code, GenericErrorType.DEFAULT_ERROR, error);
    }
    this.datadogService.addCustomEvent('Llamada zytrust verification', environment.mode, { soliId: this.soliId, code });
    this.faceIdHandler.applicationVerify(this.soliId, code).subscribe(
      (response) => {
          this.handleSuccess(response);
      },
      (err) => {
        this.setGenericErrorObject('Catch llamada zytrust verification', code, GenericErrorType.DEFAULT_ERROR, error);
        this.handleGenericError();
      }
    );
  }

  async handleSuccess(data) {
    this.datadogService.addCustomEvent('Respuesta zytrust verification', environment.mode, { response: data });
    if (data.code === OCRResponseStatus.OK) {
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_TERMS_CONDITIONS }));
    } else if (!data.code && this.genericErrorInfo.code) {
      this.handleGenericError();
    } else {
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SUCURSAL_DERIVATION }));
    }
  }

  handleGenericError() {
    const code = this.genericErrorInfo.code;
    const error = this.genericErrorInfo.error;
    this.datadogService.addCustomEvent(this.genericErrorInfo.ddmessage, environment.mode, { code, error });
    this.dataNotClientService.setGenericErrorType(this.genericErrorInfo.genericError);
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
  }

  setGenericErrorObject(ddmessage?: string, code?: FaceCode, genericError?: GenericErrorType, error?) {
    this.genericErrorInfo.ddmessage = ddmessage;
    this.genericErrorInfo.code = code;
    this.genericErrorInfo.genericError = genericError;
    this.genericErrorInfo.error = error;
  }

  nextAdvice() {
    this.requestSent = true;
    if (this.item < this.suggestionData.instructions.length - 1) {
      this.item++;
    }
    setTimeout(() => {
      this.requestSent = false;
    }, 300);
  }
}
